import { FC } from 'react';
import { useAdvertBottomSheetContext } from '#advertBottomSheet/hooks';

const AdvertBottomSheetWrapper: FC = () => {
  const { AdvertBottomSheet, isLoaded } = useAdvertBottomSheetContext();

  if (!isLoaded) {
    return null;
  }

  return <AdvertBottomSheet />;
};

export { AdvertBottomSheetWrapper };
